import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const referralManagementSlice = createSlice({
    name: "referralManagement",
    initialState: {
        page: 0,
        pageCount: 0,
        totalRow: 0,
        listData: null,
        detailData: null,
        reportsData: null,
        success: false,
        fail: false,
        errorDetailData: null,
    },
    reducers: {
        doGetReferralUsersListSuccess: (state, action) => {
            state.listData = action.payload.data;
            state.page = action.payload?.current_page;
            state.pageCount = action.payload?.page_count;
            state.totalRow = action.payload?.total_row;
        },
        doGetReferralUsersListFail: (state) => {
            state.listData = null;
            state.page = 0;
            state.pageCount = 0;
            state.totalRow = 0;
        },
        doGetReferralUserDetailSuccess: (state, action) => {
            state.detailData = action.payload.data;
        },
        doGetReferralUserDetailFail: (state) => {
            state.detailData = null;
        },
        doGetReferralReportsSuccess: (state, action) => {
            state.reportsData = action.payload.data;
        },
        doGetReferralReportsFail: (state) => {
            state.reportsData = null;
        },
        doUpdateUserRateSuccess: (state) => {
            state.success = true;
            state.fail = false;
        },
        doUpdateUserRateFail: (state, action) => {
            state.success = false;
            state.fail = true;
            state.errorDetailData = action.payload;
        },
        resetReferralManagementStateSuccess: (state) => {
            state.success = false;
            state.fail = false;
            state.errorDetailData = null;
        },
    },
});

export const doGetReferralUsersList = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/referral-management/users?page=${param.page}&size=${param.limit}`;
        if (param.search) url += `&search=${encodeURIComponent(param.search)}`;
        const response = await axios.get(url);
        dispatch(doGetReferralUsersListSuccess(response.data));
    } catch (error) {
        dispatch(doGetReferralUsersListFail(error.response));
    }
};

export const doGetReferralUserDetail = (param) => async (dispatch) => {
    try {
        const response = await axios.get(`/api/admin/referral-management/users/${param.id}`);
        dispatch(doGetReferralUserDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetReferralUserDetailFail(error.response));
    }
};

export const doGetReferralReports = () => async (dispatch) => {
    try {
        const response = await axios.get(`/api/admin/referral-management/reports`);
        dispatch(doGetReferralReportsSuccess(response.data));
    } catch (error) {
        dispatch(doGetReferralReportsFail(error.response));
    }
};

export const doUpdateUserRate = (id, param) => async (dispatch) => {
    try {
        const response = await axios.put(`/api/admin/referral-management/users/${id}/rate`, param);
        dispatch(doUpdateUserRateSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateUserRateFail(error.response));
    }
};

export const resetReferralManagementState = () => async (dispatch) => {
    dispatch(resetReferralManagementStateSuccess());
};

export const {
    doGetReferralUsersListSuccess,
    doGetReferralUsersListFail,
    doGetReferralUserDetailSuccess,
    doGetReferralUserDetailFail,
    doGetReferralReportsSuccess,
    doGetReferralReportsFail,
    doUpdateUserRateSuccess,
    doUpdateUserRateFail,
    resetReferralManagementStateSuccess,
} = referralManagementSlice.actions;

export const getReferralUsersList = (state) => state.referralManagement?.listData;
export const getReferralUsersPage = (state) => state.referralManagement?.page;
export const getReferralUsersPageCount = (state) => state.referralManagement?.pageCount;
export const getReferralUsersTotal = (state) => state.referralManagement?.totalRow;
export const getReferralUserDetail = (state) => state.referralManagement?.detailData;
export const getReferralReports = (state) => state.referralManagement?.reportsData;
export const getReferralManagementSuccess = (state) => state.referralManagement?.success;
export const getReferralManagementFail = (state) => state.referralManagement?.fail;
export const getReferralManagementErrorData = (state) => state.referralManagement?.errorDetailData;

export default referralManagementSlice.reducer;
